import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const initialPath = window.location.pathname;
let reloadPending =
  (performance.getEntriesByType("navigation")[0] || {}).type === "reload";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    if (pathname !== initialPath) reloadPending = false;

    const key = `scroll:${pathname}`;
    const isReload = reloadPending && pathname === initialPath;
    const target = isReload ? Number(sessionStorage.getItem(key)) || 0 : 0;

    let restoring = target > 0;
    let rafId;
    const start = Date.now();

    const stopRestoring = () => {
      restoring = false;
    };

    if (restoring) {
      window.addEventListener("wheel", stopRestoring, { passive: true });
      window.addEventListener("touchstart", stopRestoring, { passive: true });
      window.addEventListener("keydown", stopRestoring);

      const tryRestore = () => {
        if (!restoring) return;
        window.scrollTo(0, target);
        const reached = Math.abs(window.scrollY - target) < 5;
        if (reached || Date.now() - start > 3000) {
          restoring = false;
          return;
        }
        rafId = requestAnimationFrame(tryRestore);
      };
      tryRestore();
    } else {
      window.scrollTo(0, 0);
    }

    const save = () => {
      if (!restoring) sessionStorage.setItem(key, String(window.scrollY));
    };
    window.addEventListener("pagehide", save);
    window.addEventListener("beforeunload", save);

    return () => {
      cancelAnimationFrame(rafId);
      window.removeEventListener("wheel", stopRestoring);
      window.removeEventListener("touchstart", stopRestoring);
      window.removeEventListener("keydown", stopRestoring);
      window.removeEventListener("pagehide", save);
      window.removeEventListener("beforeunload", save);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop;